import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import IconButton from '@mui/material/IconButton';

/**
 * Componente reutilizável para navegação entre registros de uma coleção
 *
 * @param {Object} props - Propriedades do componente
 * @param {number} props.currentIndex - Índice atual selecionado (0-based)
 * @param {number} props.totalRecords - Total de registros disponíveis
 * @param {function} props.onNavigate - Função chamada ao navegar (recebe o novo índice)
 * @param {string} props.className - Classes adicionais para estilização
 * @returns {JSX.Element} Componente de navegação
 */
const RecordNavigator = ({ currentIndex = 0, totalRecords = 0, onNavigate, className = '' }) => {
  // Se tiver apenas um ou nenhum registro, não renderiza o navegador
  if (totalRecords <= 1) return null;

  // Handler para navegar para o registro anterior
  const handlePrevious = () => {
    if (currentIndex > 0 && onNavigate) {
      onNavigate(currentIndex - 1);
    }
  };

  // Handler para navegar para o próximo registro
  const handleNext = () => {
    if (currentIndex < totalRecords - 1 && onNavigate) {
      onNavigate(currentIndex + 1);
    }
  };

  return (
    <div className={`flex items-center gap-1 bg-gray-100 rounded p-1 ${className}`}>
      <IconButton
        size="small"
        onClick={handlePrevious}
        disabled={currentIndex === 0}
        className={currentIndex === 0 ? 'text-gray-400' : 'text-gray-700'}
      >
        <ChevronLeft size={16} />
      </IconButton>
      <div className="text-sm text-gray-700 px-2 py-1">
        {currentIndex + 1} de {totalRecords}
      </div>
      <IconButton
        size="small"
        onClick={handleNext}
        disabled={currentIndex === totalRecords - 1}
        className={currentIndex === totalRecords - 1 ? 'text-gray-400' : 'text-gray-700'}
      >
        <ChevronRight size={16} />
      </IconButton>
    </div>
  );
};

export default RecordNavigator;
